import { render } from "./PosteVoyage.vue?vue&type=template&id=1e222eb6&ts=true"
import script from "./PosteVoyage.vue?vue&type=script&lang=ts"
export * from "./PosteVoyage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__